import DynamoDB from 'aws-sdk/clients/dynamodb';
import { APNDataType, FCMDataType } from './interface';

export const getFCMData = async (
  envId: string
): Promise<FCMDataType | undefined> => {
  const ddb = new DynamoDB.DocumentClient();
  const item = await ddb
    .get({
      Key: {
        envId
      },
      TableName: 'Firebase_FCM'
    })
    .promise();

  return item.Item
    ? {
        fcmConfig: item.Item.fcmConfig
      }
    : undefined;
};
export const putFCMData = async (
  envId: string,
  fcmConfig: string
): Promise<FCMDataType> => {
  const ddb = new DynamoDB.DocumentClient();
  await ddb
    .put({
      Item: {
        envId,
        fcmConfig
      },
      TableName: 'Firebase_FCM'
    })
    .promise();

  return {
    fcmConfig
  };
};
export const getAPNData = async (
  envId: string
): Promise<APNDataType | undefined> => {
  const ddb = new DynamoDB.DocumentClient();
  const item = await ddb
    .get({
      Key: {
        envId
      },
      TableName: 'APN_configs'
    })
    .promise();
  return item.Item
    ? {
        Topic: item.Item.Topic,
        Key: item.Item.Key,
        KeyId: item.Item.KeyId,
        TeamId: item.Item.TeamId
      }
    : undefined;
};
export const putAPNData = async (
  envId: string,
  Topic: string,
  Key: string,
  KeyId: string,
  TeamId: string
): Promise<APNDataType> => {
  const ddb = new DynamoDB.DocumentClient();
  await ddb
    .put({
      Item: {
        envId,
        Topic,
        Key,
        KeyId,
        TeamId
      },
      TableName: 'APN_configs'
    })
    .promise();

  return {
    Topic,
    Key,
    KeyId,
    TeamId
  };
};
